import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFundedTraderWidthAccountData } from "../../api/funds/index.types";

export interface IFundedTradersState {
  data: {
    funded_traders: IFundedTraderWidthAccountData[];
    count: number;
  };
  isLoading: boolean;
}

const initialState: IFundedTradersState = {
  data: {
    funded_traders: [],
    count: 0,
  },
  isLoading: false,
};

interface FetchSuccessPayload {
  count: number;
  funded_traders: IFundedTraderWidthAccountData[];
}

const index = createSlice({
  name: "fundedTraders",
  initialState,
  reducers: {
    fetchFailedPaymentsRequest: (state) => {
      state.isLoading = true;
    },
    fetchFailedPaymentsSuccess: (state, action: PayloadAction<FetchSuccessPayload>) => {
      state.data.funded_traders = action.payload.funded_traders;
      state.data.count = action.payload.count;
      state.isLoading = false;
    },
    fetchFailedPaymentsFailed: (state) => {
      state.isLoading = false;
    },
  },
});

export const fundedTradersActions = index.actions;
export default index.reducer;
